<template>
    <div id="picture">
        <nav>
            <center>
                <img id="logo" v-on:click="reload()" src="/assets/logo.png" alt="SO" />
            </center>
        </nav>
        <h1>Accueil</h1>
        <p>
            Compte {{this.$cookie.get('role')}}
        </p>
        <input type="file" @change="onFileSelected">
        <button type="button" v-on:click="upload()">upload</button>
        <h2>Liste Buildings</h2>
          <div v-for="item in buildings" :key="item._id">
            {{ item.name }}
          </div>
        <img id="building" :src="displayedImg" alt="SO" />
        <button type="button" v-on:click="goToPicture()">Prendre une photo</button>
        <button type="button" v-on:click="logout()">Déconnexion</button>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        name: 'Picture',
        data() {
            return {
                buildings : [],
                files : [],
                displayedImg : [],
                imageType: ""
            };
        },
        methods:{
            logout() {
                this.$cookie.delete('jwt');
                this.$cookie.delete('role');
                this.$cookie.set('firstName');
                this.$cookie.set('lastName');
                this.$cookie.delete('currentAriane');
                this.$cookie.delete('fromQuery');
                this.$cookie.delete('fromPage');
                this.$cookie.delete('fromPagePrev');
                this.$cookie.delete('fromQueryPrev');
                this.$router.replace({ name: "login" });
            },
            dataUrl(){
                console.log(this.displayedImg);
                return 'data:'+this.imageType+';base64,' + btoa(
                    new Uint8Array(this.displayedImg).reduce((data, byte) => data + String.fromCharCode(byte), '')
                );
            },
            goToPicture() {
                this.$router.replace({ name: "picture" });
            },
            getCookies: function() {
                if(!this.$cookie.get('jwt') || !this.$cookie.get('role')){
                    this.$router.replace({ name: "login" });
                }
                else{
                    this.getBuildings();
                }
            },
            getBuildings(){
                var vm = this;
                axios.defaults.headers.common['Authorization'] = this.$cookie.get('jwt');
                axios.get('https://so.gaviota.fr/api/building')
                .then(function (response) {
                    if(response.data.buildings){
                        vm.buildings = response.data.buildings;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            },
            onFileSelected(event){
                console.log(event.target.files);
                this.files = event.target.files;
            },
            upload(){
                console.log(this.files[0])
                const fd = new FormData();
                fd.append('picture', this.files[0] ,this.files[0].name);
                console.log(fd);
                var vm = this;

                axios.put('https://so.gaviota.fr/api/building//inquiry/document/fiche_3/interventionTravailGui',fd )
                .then(function (response) {
                    console.log(response);
                    var data = new Uint8Array(response.data.building.picture.img.data.data);
                    var blob = new Blob(data, { type: "application/pdf" });
                    var url = URL.createObjectURL(blob);
                    console.log(url)
                    vm.imageType = response.data.intervention.picture[0].img.contentType;
                    vm.displayedImg = response.data.intervention.picture[0].img.data.data;
                    vm.displayedImg =vm.dataUrl();
                })
                .catch(function (error) {
                    console.log(error);
                });
            }
        },
        mounted(){
            this.getCookies();
        }
    }
</script>

<style scoped>
    #picture {
        background-color: #FFFFFF;
        border: 1px solid #CCCCCC;
        padding: 20px;
        margin-top: 100px;
        margin-left: 15px;
        margin-right: 15px;
    }
    nav{
        top:0px;
        left:0px;
        right:0px;
        margin: 0px;
        position:fixed;
        z-index:1;
        width:100%;
        background-color: white;
        border-bottom: 2px solid;
        border-color:#1ce83e;
    }
    img{
        display: inline-block; 
        cursor: pointer;
        margin:5px;
    }
</style>